@if ({ formattedValue: formattedValue$ | async }; as obj) {
  <div class="flex items-center justify-end space-x-2">
    @if (obj.formattedValue !== 0) {
      @if ({ percentage: obj.formattedValue | percent: '1.0-2' }; as percentageObj) {
        <div>
          {{ percentageObj.percentage !== '0%' ? percentageObj.percentage : '0.00%' }}
        </div>
      }
      @if (isValuePositive) {
        <aux-icon name="CircleArrowUpFilled" class="flex-shrink-0 text-aux-error" />
      }
      @if (!isValuePositive) {
        <aux-icon name="CircleArrowDownFilled" class="flex-shrink-0 text-aux-green" />
      }
    }

    @if (obj.formattedValue === 0) {
      <p>{{ zeroHyphen }}</p>
    }
  </div>
}
